import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getAppConfig(payload) {
    const result = await axios.post(apiUrl + "/admin/get/appconfigs",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function updateAppConfig(payload) {
    const resultuser = await axios.post(apiUrl + "/admin/update/appconfig",payload,{
        headers: jsonHeader}
    );
    return resultuser.data || [];
}

async function refreshScript(payload) {
    const result = await axios.post(apiUrl + "/admin/refreshscript", payload, {
        headers: jsonHeader}
    );
    return result.data || [];
}


export const AppConfigServices = {
    getAppConfig,
    updateAppConfig,
    refreshScript
}